import { Fragment, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  CREATE_FOLDER,
  DELETE_FILE,
  DELETE_FOLDER,
  MOVE_FILE,
  MOVE_FOLDER,
  NODE_URL,
  UPLOAD_FILE,
} from "../../../utils/constants";
import { hideMessage } from "../../../utils/customer/artifactSlice";
import { useNavigate, useParams } from "react-router-dom";
import useRequireAuth from "../../../utils/useRequireAuth";
import DocumentModalFile from "./DocumentModalFile";
import { useFetchCustomerDocumentDataQuery, usePostApiMutation } from "../../../utils/customer/customerTaskTable";
import ViewIcon from "../../../assets/images/icons/ViewEye.svg";
import PlusIcon from "../../../assets/images/icons/PlusIcon";
import { ReactComponent as ActivitiyIconNew } from "../../../assets/images/icons/ActivityIconNew.svg";
import { Menu, MenuItem, ListItemIcon } from "@mui/material";
import { ReactComponent as FolderIcon } from "../../../assets/images/icons/FolderIcon.svg";
import AttachmentIcon from "@mui/icons-material/Attachment";
import FolderAction from "./FolderAction";
import ShareDocModal from "./ShareDocModal";
import { pushAlert } from "../../../utils/alertSlice";
import OverviewDialog from "./OverviewDialog";
import RequestAccessDialog from "./RequestAccessDialog";
import ApproverDialogue from "./ApproverDialogue";
import ToolTipComponent from "../../UniversalComponents/ToolTipComponent";
import CustomerEditTaskActivity from "../CustomerEditTaskActivity";
import { getCompanyId, getUserToken } from "../../../utils/utilityFunctions/localServices";
import ReactTableComponent from "../../UniversalComponents/ReactTableComponent";
import Breadcrumb from "../../UniversalComponents/Breadcrumb";
import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import DeleteIcon from "@mui/icons-material/Delete";
import ShareIcon from "@mui/icons-material/Share";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";
import DocumentIcon from "../../../utils/utilityFunctions/iconUtility";
import FileExplorer from "../../UniversalComponents/FileExplorer";
import AddItemPlus from "../../UniversalComponents/AddItemPlus";
import ContentPasteGoIcon from "@mui/icons-material/ContentPasteGo";
import MoveDocumentModal from "./MoveDocumentModal";
import AddFolderModal from "./AddFolderModal";
import { ReactComponent as NoFolderIcon } from "../../../assets/images/NoFolderIcon.svg";
import ConfirmationDialog from "../../UniversalComponents/ConfirmationDialogMulti";
import ToggleSwitch from "../../UniversalComponents/ToggleSwitch";
import InternalNavigation from "../../UniversalComponents/InternalNavigation";
import NewToggleSwitch from "../../UniversalComponents/NewToggleSwitch";
import { getUserDateTime } from "../../../utils/utilityFunctions/UTCFormat";
import { useSidebar } from "../../SidebarContext";
import Button from "../../UniversalComponents/DefaultButton";
import InternalNavigationRounded from "../../UniversalComponents/InternalNavigationRounded";
import { ReactComponent as AddTask } from "../../../assets/images/AddtaskComponent.svg";
import CustomDialog from "../../UniversalComponents/CustomDialog";
import { Title } from "@mui/icons-material";
import { useFetchAllTemplateQuery } from "../../../utils/customer/customerSelect";
import DynamicAddTaskPodModal from "../../Task/DynamicAddTaskPodModal";
import { hideLoader, showLoader } from "../../../utils/loaderSlice";

const CustomerDocument = ({
  type = "Tracking",
  initialbreadcrumpList = [{ label: "Root", isContainer: true }],
  subNavitems,
  propTemplateId,
  disableAddMode = false,
  row_id,
  core_id,
}) => {
  // console.log(subNavitems, type, "SubnavvvvDocument")

  const user = useRequireAuth();
  const navigate = useNavigate();
  const { id: customerId, tab: tabValue } = useParams();
  const dispatch = useDispatch();
  const message = useSelector((state) => state.customerArtifact.message);
  const companyLocalData = localStorage.getItem("company_data");
  const parsedCompanyData = companyLocalData ? JSON.parse(companyLocalData) : null;
  const showMessage = useSelector((state) => state.customerArtifact.showMessage);
  const [linkDocumentPreview, setLinkDocumentPreview] = useState(true);
  const [showFileUploadModal, setShowFileUploadModal] = useState(false);
  const [createMenuModal, setCreateMenuModal] = useState(null);
  const [showAddFolderModal, setShowAddFolderModal] = useState(false);
  const [folderName, setFolderName] = useState("");
  const colorOptions = ["#FACD26", "#DE3B20", "#E57000", "#4D9F45", "#3C938E", "#3785D3", "#9761CA", "#C553B6"];
  const [folderColor, setFolderColor] = useState("#FACD26"); // Default color
  const [folderId, setFolderID] = useState(null);
  const [containerId, setContainerId] = useState(null);
  const [secondPopupOpen, setSecondPopupOpen] = useState(false);
  const [dataMove, setDataMove] = useState({});
  const [showShareDialog, setShareDialog] = useState(false);
  const [showAIPreviewModal, setShowAIPreviewModal] = useState(false);
  const [openMoveDialog, setOpenMoveDialog] = useState(false);
  const [requestDocumentAccessModal, setRequestDocumentAccessModal] = useState(false);
  const [openApproverDialog, setOpenApproverDialog] = useState(false);
  const [openActivityDialog, setOpenActivityDialog] = useState(false);
  const [activityId, setActivityId] = useState("");
  const [uuidDoc, setUuidDoc] = useState(null);
  const [leadTypeValue, setLeadTypeValue] = useState("task");
  const [taskClickCustomer, setTaskClickCustomer] = useState(null);
  // const [showFilePreviewDialog, setShowFilePreviewDialog] = useState(false);
  // const [selectedRowData, setSelectedRowData] = useState({});

  const [breadcrumpList, setBreadcrumpList] = useState(initialbreadcrumpList);
  const [showPasteButton, setShowPasteButton] = useState(false);

  const [isListView, setIsListView] = useState(true);

  const [deleteData, setDeleteData] = useState({});

  const {
    data: customerDocumentData,
    refetch: refetchCustomerData,
    isLoading,
  } = useFetchCustomerDocumentDataQuery({
    customerId: customerId ?? core_id,
    folderId: folderId ? folderId : "",
    userId: user.user_id,
    orgId: user.org_id,
    companyId: getCompanyId(),
    token: user?.token,
    type: type,
    templateId: propTemplateId,
    row_id: row_id,
    core_id: core_id,
  });

  //For setting data in Header
  const sidebarContext = useSidebar();
  const setheaderProps = sidebarContext?.setheaderProps;
  const headerProps = sidebarContext?.headerProps;

  function MySpaceHeaderUI() {
    return <NewToggleSwitch onToggle={handleToggle} toggleState={isListView} className={"w-30 h-8"} />;
  }

  useEffect(() => {
    setheaderProps({ ...headerProps });
    return () => {
      setheaderProps({ ...headerProps });
      document.title = "Zinancial";
    };
  }, [setheaderProps]);

  useEffect(() => {
    if (initialbreadcrumpList.length > 1) {
      setFolderID(initialbreadcrumpList[initialbreadcrumpList.length - 1].id);
    }
  }, [initialbreadcrumpList]);

  const handleToggle = () => {
    setIsListView((prev) => !prev);
  };

  const handleMove = (item, action) => {
    setDataMove({ action: action, dirPath: breadcrumpList[breadcrumpList.length - 1], ...item });
    setOpenMoveDialog(true);
  };

  /* NOTE: handlePaste function agrument consist "dragToItem" which is the item where we need to paste the data.
    1. handlePaste argument(dragToItem) should be empty if not using drag/drop option.
    2. "dataMove" consist the data which we need to move.
    3. "breadcrumpList" consist the data where we need to paste the data.
    4. "dataMove" and "dragToItem" should not be same. */
  const handlePaste = (dragToItem) => {
    let item = {};
    if (dragToItem?.type) {
      // Simply check the dragable item should be draged in itself (DragtoItem and dataMove should not be same.)
      if (dragToItem?.id !== dataMove?.id) {
        item = dragToItem;
      } else {
        return;
      }
    } else {
      if (dataMove?.dirPath?.label !== breadcrumpList[breadcrumpList.length - 1]?.label) {
        // Collecting breadcrump data to define where to put data and "dataMove" consist what data needed to move.
        item = breadcrumpList[breadcrumpList.length - 1];
      } else {
        return;
      }
    }
    if (dataMove?.type === "folder") handleMoveFolder(item);
    else handleMoveFile(item);
  };

  const handleShare = (item) => {
    setShareDialog(true);
  };
  const handleOverview = (item) => {
    setShowAIPreviewModal(true);
  };

  const handleRequestAccess = (item, action) => {
    setRequestDocumentAccessModal(true);
  };

  const handleMoveFolder = async (data) => {
    const folderData = {
      userId: user.user_id,
    };

    if (dataMove.action === "move") {
      if (data.isContainer) folderData.containerId = data.id;
      else folderData.parentId = data.id;
    } else folderData.targetparentId = data.id;

    try {
      const response = await fetch(`${MOVE_FOLDER}${dataMove.id}/${dataMove.action}`, {
        method: "Post",
        headers: {
          Authorization: `Bearer ${user?.token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(folderData),
      });

      if (response.ok) {
        // Handle success, maybe close the dialog or show a success message
        // handleDialogClose();
        setOpenMoveDialog(false);
        // await fetchData(customerId);
        dispatch(pushAlert({ type: "success", message: "Folder moved successfully", visible: true }));
        setDataMove({});
        refetchCustomerData();
      } else {
        dispatch(pushAlert({ type: "danger", message: response?.message, visible: true }));
        console.error("Error creating folder:", response.statusText);
      }
    } catch (error) {
      dispatch(pushAlert({ type: "danger", message: error?.message, visible: true }));
      console.error("Network error:", error);
    }
  };

  const handleMoveFile = async (data) => {
    const fileData = {
      userId: user.user_id,
      targetId: data.id,
      isContainer: data.isContainer,
    };

    try {
      const response = await fetch(`${MOVE_FILE}${dataMove.id}/${dataMove.action}`, {
        method: "Post",
        headers: {
          Authorization: `Bearer ${user?.token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(fileData),
      });

      if (response.ok) {
        setOpenMoveDialog(false);
        dispatch(pushAlert({ type: "success", message: "File moved successfully", visible: true }));
        setDataMove({});
        refetchCustomerData();
      } else {
        dispatch(pushAlert({ type: "danger", message: response?.message, visible: true }));
        console.error("Error creating folder:", response.statusText);
      }
    } catch (error) {
      dispatch(pushAlert({ type: "danger", message: error?.message, visible: true }));
      console.error("Network error:", error);
    }
  };

  const handleSubmitData = async (fileData) => {
    const formData = new FormData();

    for (var key in fileData) {
      formData.append(key, fileData[key]);
    }

    // formData.append(...fileData);
    try {
      const response = await fetch(
        `${UPLOAD_FILE}?userId=${user.user_id}&${folderId ? `folderId=${folderId}` : `containerId=${containerId}&${propTemplateId ? `template_id=${propTemplateId}` : `type=${type}`}`}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
          body: formData,
        }
      );

      if (response?.success || response?.data?.success || response?.data?.status || response?.ok) {
        // Handle success, maybe close the dialog or show a success message
        refetchCustomerData();
        handleDialogClose();
        dispatch(pushAlert({ type: "success", message: response?.message, visible: true }));
        // await fetchData(customerId);
      } else {
        dispatch(pushAlert({ type: "danger", message: response?.message, visible: true }));
        console.error("Error creating folder:", response.statusText);
      }
    } catch (error) {
      dispatch(pushAlert({ type: "danger", message: "Something went wrong", visible: true }));
      console.error("Network error:", error);
    }
  };

  const handleOpenFolder = (folder) => {
    setBreadcrumpList((prev) => [...prev, { label: folder.display_name, isContainer: false, id: folder.id }]);

    setFolderID(folder.id);
  };

  const handleDirectory = (val) => {
    if (val.isContainer) setFolderID(null);
    else {
      const newArr = breadcrumpList;

      setFolderID(val.id);
      setBreadcrumpList(newArr.slice(0, newArr.findIndex((item) => val.id === item.id) + 1));
    }
  };

  const handleRowClick = (data) => {
    try {
      if (data?.type === "folder") {
        const getSelectedDataIndex = customerDocumentData?.data?.data?.findIndex((option) => {
          return data?.auto_id === option?.auto_id;
        });

        const selectedData = customerDocumentData?.data?.data[getSelectedDataIndex];

        setFolderID(data?.id);
        setBreadcrumpList((prev) => {
          return [...prev, { label: selectedData?.display_name, isContainer: false, ...selectedData }];
        });
      }
    } catch (error) {
      console.log(error?.message);
    }
  };

  const handleBreadcrumpDataClicked = (data) => {
    if (data?.id) {
      if (data.isContainer) setFolderID(null);
      else setFolderID(data?.id);
    }

    // Assuming to be the initial option for breadcrump
    // Hence, resetting for initial state
    else {
      setFolderID();
      setBreadcrumpList([{ label: "Root", isContainer: true }]);
    }
  };

  const handleDirectoryBack = () => {
    const newArr = breadcrumpList.slice(0, breadcrumpList.length - 1);
    if (newArr.length > 1) setFolderID(newArr[newArr.length - 1].id);
    else setFolderID(null);
    setBreadcrumpList(newArr);
  };

  useEffect(() => {
    if (showMessage === true) {
      dispatch(
        pushAlert({
          visible: true,
          message: message || "Operation successful",
          type: "success",
        })
      );
      refetchCustomerData();
    }
  }, []);

  useEffect(() => {
    refetchCustomerData();
    console.log(type, "folderId yupe type");
  }, [folderId, type]);

  useEffect(() => {
    if (customerDocumentData) {
      setContainerId(customerDocumentData?.data?.container_id);
      const { data: omitData, ...restData } = customerDocumentData?.data;
      if (customerDocumentData?.data?.container_id) {
        setBreadcrumpList([{ label: "Root", isContainer: true, id: customerDocumentData.data.container_id }]);
      }
    }
  }, [customerDocumentData]);

  const openPopup = () => {
    setShowFileUploadModal(true);
    handleMenuClose();
  };

  const closePopup = () => {
    setShowFileUploadModal(false);
  };

  const handleMenuOpen = (event) => setCreateMenuModal(event.currentTarget);
  const handleMenuClose = () => setCreateMenuModal(null);

  const openFolderDialog = () => {
    setShowAddFolderModal(true);
    handleMenuClose();
  };

  const handleActivityDialog = (item) => {
    console.log(item, "item...");
    setActivityId(item?.auto_id);
    setUuidDoc(item?.id);
    setOpenActivityDialog(true);
  };

  const handleDialogClose = () => setShowAddFolderModal(false);
  const handleFolderNameChange = (event) => {
    setFolderName(event.target.value);
  };
  const handleColorSelect = (color) => setFolderColor(color);

  const handleSubmit = async () => {
    const folderData = {
      folderName: folderName,
      color: folderColor,
      userId: user.user_id,
      companyId: parsedCompanyData.company_id,
      customerId: customerId ?? core_id,
      orgId: user.org_id,
      parentFolderId: folderId,
    };

    try {
      const response = await fetch(
        propTemplateId ? `${CREATE_FOLDER}?template_id=${propTemplateId}` : `${CREATE_FOLDER}?type=${type}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${user?.token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(folderData),
        }
      );

      if (response?.status) {
        handleDialogClose();
        refetchCustomerData();
        dispatch(pushAlert({ type: "success", message: "Folder created successfully", visible: true }));
        setFolderName("");
      } else {
        dispatch(pushAlert({ type: "danger", message: `${response?.message}`, visible: true }));
      }
    } catch (error) {
      console.error("Network error:", error);
    }
  };

  const handleNewFolderOptionClick = () => {
    setShowAddFolderModal(true);
    handleMenuClose();
  };

  const handleNewFileOptionClick = () => {
    setShowFileUploadModal(true);
    handleMenuClose();
  };

  const handleShareOptionClick = () => {
    setShareDialog(true);
  };

  const handleMoveOptionClick = (rowData) => {
    setShowPasteButton(false);
    setDataMove({ action: "move", dirPath: breadcrumpList[breadcrumpList.length - 1], ...rowData });
    if (isListView) {
      setOpenMoveDialog(true);
    }
  };

  const handleCopyOptionClick = (rowData) => {
    if (dataMove.type === "folder") handleMoveFolder(rowData);
    else handleMoveFile(rowData);
  };

  const {
    refetch: refetchGetAllTemplate,
    data: GetAlltemplates,
    isLoading: isGetAllTemplatesLoading,
    isError: isGetAllTemplatesError,
    isSuccess: isGetAllTemplatesSuccess,
    error: GetAllTemplatesError,
  } = useFetchAllTemplateQuery();

  //post the task pod data
  const [
    createUpdateTask,
    {
      data: taskPodData,
      isLoading: isTaskPodLoading,
      isError: isTaskPodError,
      isSuccess: isTaskPodSuccess,
      error: TaskPodErrordata,
    },
  ] = usePostApiMutation();

  //post the task pod data useEffect
  useEffect(() => {
    //loading
    if (isTaskPodLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    //try block
    if (isTaskPodSuccess) {
      dispatch(
        pushAlert({
          message: taskPodData?.message,
          type: taskPodData.success || taskPodData.success ? "success" : "danger", // success is not comming form backend
          visible: true,
        })
      );
      closeSecondPopup();
    }

    // catch block
    if (isTaskPodError) {
      dispatch(pushAlert({ message: TaskPodErrordata?.data?.message, type: "danger", visible: true }));
    }
  }, [isTaskPodSuccess, isTaskPodError, isTaskPodLoading, taskPodData]);

  const handleSubmitTask = async (data) => {
    const templateId = GetAlltemplates?.data?.find(
      (template) => template?.template_name?.toLowerCase() === data?.category_id?.toLowerCase()
    )?.id;
    // if(templateId){
    //   setCategoryId(templateId)
    // }
    const {
      frequency,
      interval,
      day_of_month,
      day_of_week,
      start_date,
      start_time,
      end_date,
      end_time,
      update_entire_series,
      weekly_days,
      yearly_option,
      occurrences,
      monthly_week,
      monthly_option,
      daily_option,
      ...RemFormData
    } = data;

    const recurrence = {
      frequency,
      interval,
      day_of_month,
      day_of_week,
      start_date,
      start_time,
      end_date,
      end_time,
      weekly_days,
      yearly_option,
      occurrences,
      monthly_week,
      monthly_option,
      daily_option,
    };
    const OnlyDynamicFields = { ...RemFormData, start_date, end_date };

    const payload = {
      // row_id: tableRowId ? tableRowId : null,
      template_id: data ? templateId : null, // task create for the category
      document_id: taskClickCustomer?.id,
      data: OnlyDynamicFields,
      // update_single_recurrence: !taskid?.recurModal ? true : false,
      // edit_entire_recurrence: taskid?.recurModal ? true : false,
    };
    if (data?.is_recurrence) {
      payload.recurrence = recurrence;
    }
    createUpdateTask({
      data: payload,
      url: `${NODE_URL}task/linkTaskToDocument?template_id=${containerId}&row_id=${null}`,
    }); // module id
  };

  const handleAddTask = (data) => {
    if (data) {
      console.log(data, "vianykuar");
      setLeadTypeValue("task");
      setTaskClickCustomer({
        customer_name: customerId ?? core_id,
        id: data?.id,
        data: data,
      });
      setSecondPopupOpen(true);
    }
  };

  const closeSecondPopup = () => {
    setSecondPopupOpen(false);
  };

  const HEADER_DEFINITION = [
    {
      accessor_key: "display_name",
      label: "Document",
      callingFunction: () => console.log("Called document Function"),
      callingFunctionMore: () => console.log("Called document Functionmore"),
      state: () => console.log("about document"),
      selfContent: (data, headerKey) => (
        <div className="flex flex-row justify-between gap-2">
          <span className="flex flex-row gap-2 items-center">
            {data.type === "folder" ? (
              <FolderIcon
                className="cursor-pointer"
                fill={data?.color}
                onClick={(e) => {
                  e.stopPropagation();
                  handleOpenFolder(data);
                }}
              />
            ) : (
              <DocumentIcon type={data.type} filename={data?.display_name} />
            )}
            <span>{data?.display_name?.substring(0, 20)}</span>
          </span>
          <span className="flex items-center gap-2">
            <FolderAction
              Item={data}
              handleMove={handleMove}
              handlePaste={handlePaste}
              showButtons={true}
              handleShare={handleShare}
              handleOverview={handleOverview}
              handleRequestAccess={handleRequestAccess}
              handleAddTask={() => handleAddTask(data)}
              documentType={data?.type}
            />
          </span>
        </div>
      ),
    },
    { accessor_key: "type", label: "Type", titleCase: true },
    { accessor_key: "created_by", label: "Created By", titleCase: true },
    {
      accessor_key: "created_at",
      label: "Created At",
      // dateColumn: "DD MMM YYYY hh:mm A",
      callingFunction: () => console.log("Called Column Created Date"),
      selfContent: (columnData, headerKey) => <span>{getUserDateTime(columnData?.created_at)}</span>,
    },
    {
      accessor_key: "activity",
      label: "Activity",
      callingFunction: () => console.log("Called Column Activity"),
      selfContent: (columnData, headerKey) => (
        <ActivitiyIconNew
          className="flex flex-row hover:transform hover:scale-125 gap-2 justify-centre items-centre w-5 h-5 mr-3"
          onClick={(e) => {
            e.stopPropagation();
            handleActivityDialog(columnData);
          }}
        />
      ),
    },
    // { accessor_key: "status", label: "Status", callingFunction: () => console.log("Called Column Status") },
    {
      accessor_key: "action",
      label: "Action",
      callingFunction: () => console.log("Called Column Action"),
      selfContent: (columnData, headerKey) => (
        <Fragment>
          <td className={`w-[150px] text-left`}>
            <div className="w-fit">
              <div className={`pr-[10px] flex gap-2 justify-end invisible group-hover:visible`}>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setDeleteData(columnData);
                  }}
                  className="text-F84545 text-15 text-left ml-3"
                >
                  {" "}
                  <i class="bi bi-trash3 text-lg text-F84545 font-600"></i>{" "}
                </button>

                {columnData?.type === "file" && (
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      window.open(columnData.access_sas_link);
                    }}
                    className="text-F84545 text-15 text-left invisible group-hover:visible"
                  >
                    <img src={ViewIcon} alt="View Doc Button" />
                  </button>
                )}
              </div>
            </div>
          </td>
        </Fragment>
      ),
    },
  ];

  const NO_DATA_FOUND_TABLE_JSX = (
    <div className="flex justify-center items-center flex-col space-y-2 group grow min-h-0">
      <NoFolderIcon />
      <span className="text-14 flex flex-col items-center text-[#666666]  font-400 font-Inter">
        No documents found. {!disableAddMode && "Create a folder or upload files."}
        {!disableAddMode && (
          <Button onClick={handleMenuOpen} className="py-1 px-3 w-fit">
            Create/Upload File
          </Button>
        )}
      </span>
      {/* <span
        onClick={handleMenuOpen}
        className="border px-5 py-1.5 items-center text-center text-sm font-400  hover:border-[#1D4469] cursor-pointer hover:text-[#1D4469] text-[#383838] rounded-3xl shadow-[0px_1px_0px_0px_rgba(0,0,0,0.10)_inset,0px_0px_4px_0px_rgba(0,0,0,0.15)]"
      >
        + Upload
      </span> */}
    </div>
  );

  const DOCUEMNT_CONTEXT_MENU = [
    {
      label: "Rename",
      icon: <DriveFileRenameOutlineIcon />,
      onClick: () => console.log("Rename Clicked"),
    },
    {
      label: "Move",
      icon: <DriveFileMoveIcon />,
      onClick: (rowData) => handleMoveOptionClick(rowData),
    },
    {
      label: "Copy",
      icon: <ContentCopyIcon />,
      onClick: (rowData) => handleCopyOptionClick(rowData),
    },
    {
      label: "Paste",
      icon: <ContentPasteGoIcon />,
      onClick: () => handlePaste(),
    },
    // {
    //   label: "Share",
    //   icon: <ShareIcon />,
    //   onClick: () => handleShareOptionClick(),
    // },
    {
      label: "Delete",
      icon: <DeleteIcon />,
      onClick: (data) => setDeleteData(data),
    },
  ];

  const OUTER_DOCUEMNT_CONTEXT_MENU = [
    {
      label: "New Folder",
      icon: <CreateNewFolderIcon />,
      onClick: () => handleNewFolderOptionClick(),
    },
    {
      label: "Upload File",
      icon: <InsertDriveFileIcon />,
      onClick: () => handleNewFileOptionClick(),
    },
    {
      label: "Paste",
      icon: <ContentPasteGoIcon />,
      onClick: () => handlePaste(),
    },
  ];

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      dispatch(hideMessage());
    }, 3000);

    return () => clearTimeout(timeoutId); // Cleanup timeout on component unmount
  }, [dispatch]);

  //  const handleConfirmDelete = (data) => {
  //   deleteData(data);
  // };

  const handleDeleteFileFolder = async () => {
    let url;
    if (deleteData.type === "file") {
      url = DELETE_FILE.replace("<ID>", deleteData.id);
    } else {
      url = DELETE_FOLDER.replace("<ID>", deleteData.id);
    }

    try {
      const jsonRes = await fetch(url, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.token}`,
        },
      });

      const respone = await jsonRes.json();
      console.log("response", respone);
      if (respone?.success || respone?.data?.success || respone?.data?.status) {
        refetchCustomerData();
        dispatch(pushAlert({ message: respone.data.message, type: "success", visible: true }));
        setDeleteData({});
      } else {
        dispatch(pushAlert({ message: respone.data.message, type: "danger", visible: true }));
        setDeleteData({});
      }
    } catch (error) {
      dispatch(pushAlert({ message: "Something went wrong", type: "danger", visible: true }));
      console.error("Error deleting file:", error);
      setDeleteData({});
    }
  };

  return (
    <div onContextMenu={(e) => e.preventDefault()} className={`h-full`}>
      {isListView ? (
        <ReactTableComponent
          tablename={
            <div className="w-fit">
              {breadcrumpList?.length > 1 && (
                <Breadcrumb
                  breadcrumpList={breadcrumpList}
                  setBreadcrumpList={setBreadcrumpList}
                  handleClick={handleBreadcrumpDataClicked}
                  maxBreadcrumpsLength={10}
                />
              )}
            </div>
          }
          narrowHeader
          headers={HEADER_DEFINITION}
          body={customerDocumentData?.data?.data || []}
          onRowClick={(data) => {
            handleRowClick(data);
          }}
          actionField={
            <Fragment>
              {!disableAddMode && (
                <ToolTipComponent text="Add">
                  <button
                    onClick={handleMenuOpen}
                    type="button"
                    className="cursor-pointer border-[#EBF2F6] rounded-md hover:bg-[#CECECE4D] hover:border-transparent flex items-center justify-center"
                  >
                    <AddItemPlus isActive={createMenuModal} width={30} height={30} />
                  </button>
                </ToolTipComponent>
              )}
              <Menu anchorEl={createMenuModal} open={Boolean(createMenuModal)} onClose={handleMenuClose} sx={{ mr: 1 }}>
                <MenuItem onClick={openFolderDialog} sx={{ fontSize: "0.75rem", color: "#2c495d" }}>
                  <ListItemIcon>
                    <FolderIcon fontSize="small" className="text-ffe851" />
                  </ListItemIcon>
                  Add Folder
                </MenuItem>
                <MenuItem onClick={openPopup} sx={{ fontSize: "0.75rem", color: "#2c495d" }}>
                  <ListItemIcon>
                    <AttachmentIcon fontSize="small" className="text-4285F4" />
                  </ListItemIcon>
                  Attach File
                </MenuItem>
              </Menu>
            </Fragment>
          }
          noDataFound={NO_DATA_FOUND_TABLE_JSX}
          alternateDivs={{ emptyData: NO_DATA_FOUND_TABLE_JSX }}
          internalNavBar={subNavitems && <InternalNavigation items={subNavitems} subTabValue={"documents"} />}
        />
      ) : (
        <FileExplorer
          tablename={
            <Breadcrumb
              breadcrumpList={breadcrumpList}
              setBreadcrumpList={setBreadcrumpList}
              handleClick={handleBreadcrumpDataClicked}
            />
          }
          breadcrumpList={breadcrumpList}
          handleBoxClick={(data) => handleRowClick(data)}
          handlePaste={handlePaste}
          setDataMove={setDataMove}
          setShowPasteButton={setShowPasteButton}
          showPasteButton={showPasteButton}
          dataMove={dataMove}
          data={customerDocumentData?.data?.data || []}
          documentContextMenu={DOCUEMNT_CONTEXT_MENU}
          outDocumentContextMenu={OUTER_DOCUEMNT_CONTEXT_MENU}
          // actionField={
          //   <Fragment>
          //     <NewToggleSwitch onToggle={handleToggle} toggleState={isListView} className={"w-30 h-9"} />
          //     <ToolTipComponent text="Add">
          //       <button onClick={handleMenuOpen} type="button" className="text-2541558A hover:text-254155">
          //         <PlusIcon isActive={createMenuModal} width={30} height={30} />
          //       </button>
          //     </ToolTipComponent>
          //     <Menu anchorEl={createMenuModal} open={Boolean(createMenuModal)} onClose={handleMenuClose} sx={{ mr: 1 }}>
          //       <MenuItem onClick={openFolderDialog} sx={{ fontSize: "0.75rem", color: "#2c495d" }}>
          //         <ListItemIcon>
          //           <FolderIcon fontSize="small" className="text-ffe851" />
          //         </ListItemIcon>
          //         Add Folder
          //       </MenuItem>
          //       <MenuItem onClick={openPopup} sx={{ fontSize: "0.75rem", color: "#2c495d" }}>
          //         <ListItemIcon>
          //           <AttachmentIcon fontSize="small" className="text-4285F4" />
          //         </ListItemIcon>
          //         Attach File
          //       </MenuItem>
          //     </Menu>
          //   </Fragment>
          // }
          noDataFound={NO_DATA_FOUND_TABLE_JSX}
          internalNavBar={() => <InternalNavigationRounded items={subNavitems} subTabValue={"documents"} />}
        />
      )}

      {/*------------ SHOW THE FILE UPLOAD MODAL -------------*/}
      {showFileUploadModal && (
        <div className="fixed inset-0 flex items-center justify-center z-[102]">
          <DocumentModalFile onClose={closePopup} handleSubmitData={handleSubmitData} />
        </div>
      )}

      {/*-------------- SHOW SHARE FOLDER/FILE MODAL --------------*/}
      {showShareDialog && (
        <div className="fixed inset-0 flex items-center justify-center z-[102]">
          <ShareDocModal
            open={showShareDialog}
            close={() => setShareDialog(false)}
            handleSubmitData={handleSubmitData}
          />
        </div>
      )}

      {/*------------ SHOW AI PREVIEW MODAL OPTION ------------*/}
      {showAIPreviewModal && (
        <OverviewDialog
          open={showAIPreviewModal}
          close={() => setShowAIPreviewModal(false)}
          handleSubmitData={handleSubmitData}
        />
      )}

      {/*------------ SHOW ConfirmationBox ------------*/}

      {Boolean(deleteData.id) && (
        <ConfirmationDialog
          open={Boolean(deleteData.id)}
          onConfirm={() => {
            handleDeleteFileFolder();
          }}
          onClose={() => setDeleteData({})}
          title="Delete"
          message={`Are you sure you want to delete ${deleteData?.display_name}?`}
          confirmVariant="delete"
          confirmText="Delete"
          cancelText="Cancel"
          iconVariant={"delete"}
        />
      )}

      {/*------------ SHOW REQUEST ACCESS MODAL (NOT FINALISED THE FUNCTIONALITY) -------------*/}
      {requestDocumentAccessModal && (
        <RequestAccessDialog
          open={requestDocumentAccessModal}
          onClose={() => setRequestDocumentAccessModal(false)}
          onClose2={() => {
            setRequestDocumentAccessModal(false);
            setOpenApproverDialog(true);
          }}
        />
      )}

      {/*------------ SHOW ACCEPT ACCESS MODAL, DEPEND ON REQUEST MODAL (NOT FINALISED THE FUNCTIONALITY) -------------*/}
      {openApproverDialog && (
        <ApproverDialogue
          open={openApproverDialog}
          close={() => {
            setOpenApproverDialog(false);
          }}
          onSubmit={() => {
            window.alert("API Integration Pending");
            setOpenApproverDialog(false);
          }}
        />
      )}

      {/*------------- SHOW MODAL TO MOVE DOCUMENT USING MODAL, ONLY FOR LIST VIEW --------------*/}
      {openMoveDialog && isListView && (
        <MoveDocumentModal
          open={openMoveDialog}
          close={() => setOpenMoveDialog(false)}
          breadcrumpList={breadcrumpList}
          setBreadcrumpList={setBreadcrumpList}
          handleRowClick={handleRowClick}
          headerData={HEADER_DEFINITION.filter((item) => ["display_name", "type"].includes(item.accessor_key))}
          handleBreadcrumpDataClicked={handleBreadcrumpDataClicked}
          bodyData={customerDocumentData?.data?.data?.filter((data) => data.type === "folder")}
          documentData={customerDocumentData?.data?.data?.filter(
            (data) => data.type === "folder" && data.id !== dataMove.id
          )}
          dataMove={dataMove}
          handleDirectory={handleDirectory}
          handleDirectoryBack={handleDirectoryBack}
          handleOpenFolder={handleOpenFolder}
          openFolderDialog={openFolderDialog}
          handlePaste={handlePaste}
        />
      )}

      {/*------------ SHOW MODAL TO ADD FOLDER ------------*/}
      {showAddFolderModal && (
        <AddFolderModal
          showAddFolderModal={showAddFolderModal}
          handleDialogClose={handleDialogClose}
          handleFolderNameChange={handleFolderNameChange}
          handleColorSelect={handleColorSelect}
          folderName={folderName}
          folderColor={folderColor}
          colorOptions={colorOptions}
          handleSubmit={handleSubmit}
        />
      )}

      {/*---------- MODAL TO SHOW ACTIVITY ------------*/}
      {openActivityDialog && (
        <CustomerEditTaskActivity
          open={openActivityDialog}
          onClose={() => {
            setOpenActivityDialog(false);
          }}
          token={getUserToken()}
          activityid={activityId}
          uuid={uuidDoc}
          type={"Document"}
        ></CustomerEditTaskActivity>
      )}

      {/*------------ PREVIEW MODAL FOR PDF FILES ------------*/}
      {/* {showFilePreviewDialog && (
        <PdfPreviewModal
          open={showFilePreviewDialog}
          onClose={() => setShowFilePreviewDialog(false)}
          fileUrl={selectedRowData?.access_sas_link}
          filename={selectedRowData?.display_name}
        />
      )} */}

      {/* add task  */}
      {secondPopupOpen && (
        <DynamicAddTaskPodModal
          templateId={taskClickCustomer?.id}
          isOpen={secondPopupOpen}
          closePopup={closeSecondPopup}
          onClose={closeSecondPopup}
          leadTypeValue={leadTypeValue}
          setLeadTypeValue={setLeadTypeValue}
          selectedCustomer={{
            customer_name: taskClickCustomer?.customer_name,
            customer_id: taskClickCustomer?.id,
            id: taskClickCustomer?.id,
          }}
          //firstPopupOpen={firstPopupOpen}
          refetch={() => {}}
          // refetch={secondPopupOpen?.refetchTaskData}
          // isDoubleComp={taskId?.recurModal}
          // recurModal={taskId?.recurModal}
          // activeModal={taskId?.activeModal}
          externalApi={{
            createUpdateTask: (data) => handleSubmitTask(data),
          }}
          isCompanyLevel={true}
          linkDocumentPreview={linkDocumentPreview}
          setLinkDocumentPreview={setLinkDocumentPreview}
        />
      )}
    </div>
  );
};

export default CustomerDocument;
